module.exports = __webpack_public_path__ + "img/foster_icon2.e0bd6628.png";